import uuid from "react-uuid";
import { FaUsers, FaCheck, FaQuestionCircle, FaUnlockAlt } from "react-icons/fa";
import { PiUsersLight } from "react-icons/pi";
import { CgNotes } from "react-icons/cg";
import { IoIosSettings, IoMdNotifications } from "react-icons/io";
import { IoAnalytics } from "react-icons/io5";
import { FcDataConfiguration } from "react-icons/fc";

export const menuItems = [
  {
    id: uuid(),
    multiple: false,
    name: "Admin Users",
    menuLink: "/AdminUsers",
    active: "AdminUsers",
    icon: FaUsers,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Customers",
    menuLink: "/customers",
    active: "Customers",
    icon: PiUsersLight,
  },
  {
    id: uuid(),
    multiple: false,
    name: "User Permissions",
    menuLink: "/permissions",
    active: "Permissions",
    icon: FaUnlockAlt,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Approval Requests",
    menuLink: "/approve-request",
    active: "approverequest",
    icon: FaCheck,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Logs",
    menuLink: "/logs",
    active: "logs",
    icon: CgNotes,
  },
  /* PHASE 4 COMMENTS */
  {
    id: uuid(),
    multiple: false,
    name: "Notifications",
    menuLink: "/all-notifications",
    active: "noti",
    icon: IoMdNotifications,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Help & Support",
    menuLink: "/faq",
    active: "FAQ",
    icon: FaQuestionCircle,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Analytics",
    menuLink: "/google-analytics",
    active: "google-analytics",
    icon: IoAnalytics,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Config",
    menuLink: "/config",
    active: "Config",
    icon: FcDataConfiguration,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Settings",
    menuLink: "/settings",
    active: "settings",
    icon: IoIosSettings,
  },

]